/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Profile_Link_ProviderInputs */

const en_profile_link_provider = /** @type {(inputs: Profile_Link_ProviderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Link ${i?.label}`)
};

const es_profile_link_provider = /** @type {(inputs: Profile_Link_ProviderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vincular ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Link {label}" |
*
* @param {Profile_Link_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_link_provider = /** @type {((inputs: Profile_Link_ProviderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Link_ProviderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_link_provider(inputs)
	return en_profile_link_provider(inputs)
});